module.exports = __webpack_public_path__ + "static/media/marlesdigitalagency.706eb406.jpg";